module.exports = __webpack_public_path__ + "static/img/logo.b848cd98.svg";